import React, { Component } from 'react';
import "./Profile.css";
import NewHeader from "../NewHeader/NewHeader";
import { getCustomerLogin , setCustomerAgentLogin, getAgentCommissionDetails, setCustomerAgentLoginProfileNew } from '../axios';
import moment from 'moment';
import DatePicker from 'react-date-picker';
import DialCode from '../PaymentDetails/DialCode';
import { Redirect } from 'react-router-dom';
import {Helmet} from "react-helmet";
//import Imageupload from "./Imageupload";

import ALL_API_CONST from "./../UrlAPI/index.jsx";
import axios, { post } from 'axios';

class Profile extends Component {

    constructor(props) {
        super(props);
        this.state = {
            plannedTrips: true,
            upcoming: false,
            cancelled: false,
            Completed: false,
            ChangeColor: 'reviewPlanned',
            customerDetails: {},
            editProfile: false,
            firstName: "",
            errorFirst: false,
            lastName: "",
            errorLast: false,
            birthday: '',
            errorBirthday: false,
            gender: "",
            errorGender: false,
            editLogin: false,
            mobile: '',
            password: '',
            errorMobile: false,
            errorPassword: false,
            hidden: false,
            changeClassForPassword: 'myPrfilSprit  txtFild__rightpasswordIcon myPrfilSprit__showPswrd',
            Redirect: false,
            ConfirmPassword: '',
            errorConfirm: false,
            editGeneral: false,
            agentName: "",
            erroragentName: false,
            corporateName: "",
            errorcorporateName: false,
            taxRegistrationno: "",
            errortaxRegistrationno: false,
            Address: "",
            errorAddress: false,
            City: "",
            errorCity: false,
            Island: "",
            errorIsland: false,
            AgentCountry: "",
            errorAgentCountry: false,
            Zipcode: "",
            errorZipcode: false,
            Commission: "",
            selectedImage: "",
           MobileCode: "",
            file: null,
            base64URL: "",
            base64URLNEW : ""
        };

    }


    getBase64 = file => {
        return new Promise(resolve => {
          let fileInfo;
          let baseURL = "";
          // Make new FileReader
          let reader = new FileReader();
    
          // Convert the file to base64 text
          reader.readAsDataURL(file);
    
          // on reader load somthing...
          reader.onload = () => {
            // Make a fileInfo Object
         
            baseURL = reader.result;
            this.setState({
                base64URLNEW: reader.result
              });
            var formdata = new FormData();
            formdata.append("file", this.state.selectedImage);
        formdata.append("agent_id", this.state.customerDetails.id);
        formdata.append("baseimg", baseURL);
       
      
            axios({
                method: 'post',
               // url: 'https://5g8stikw46.execute-api.us-east-2.amazonaws.com/Profile_Image_Upload_V2',
            //     url: 'https://api.holidays-seychelles.com/api/tour/setCustomerAgentLoginProfile',
                    url: ALL_API_CONST.login_data.setCustomerAgentLoginProfileImage,
                data: formdata,
                headers: {'Content-Type': 'multipart/form-data',Authorization: "Basic YWRtaW46MTIzNA==","x-api-key":"neeraj@123" }
                })
                .then(function (response) {
                    //handle success
                  
                })
                .catch(function (response) {
                    //handle error
                  
                });
        
            resolve(baseURL);
          };
         
        });
      };
      
    ;
    // This function will be triggered when the file field change
        imageChange = (e) => {
            if (e.target.files && e.target.files.length > 0) {
            if (e.target.files.length === 0) return false;
            const fileDatanew = e.target.files[0];
             // If no image selected, return
           
             if(e.target.files[0].size > 204800){
                 //filter out files larger than 200kb
               
                 window.alert(`Profile image do not more than 200kb.`);
                 return false;
             }
             const fileExtension = fileDatanew.name.split(".").at(-1);
             const allowedFileTypes = ["jpg", "JPG", "PNG", "jpeg", "JPEG", "png"];
             if (!allowedFileTypes.includes(fileExtension)) {
                 window.alert(`Unsupported file type. Files must be of these types: ${allowedFileTypes.join(", ")}`);
                 return false;
             }
         this.setState({selectedImage: e.target.files[0]});  
       let agenturl = URL.createObjectURL(e.target.files[0]);
   
        let data = this.state.customerDetails;
         let first_name = data.first_name;
         let last_name = data.last_name;
         let email = data.email;
         let profile_image = data.profile_pic;
         let birthday = data.birthday;
         let gender =data.gender;
         let login_source = data.login_source;
         let agent_name = data.agent_name;
         let agent_image = e.target.files[0];
         let corporate_name = data.corporate_name;
         let tax_registration = data.tax_registration;
         let address = data.address;
         let city = data.city;
         let island = data.island;
         let agent_country = data.address;
         let zip_code = data.zip_code;
 
 
         let mobile_number = data.mobile_number;
         let country = data.country;
         let country_code = data.country_code;
         let currency = data.currency;
         let ip_address = data.ip_address;
         let password = "";
         let verified = 1;
        let image = URL.createObjectURL(e.target.files[0]);
       
        // const formData = new FormData();

        // formData.append('agent_id', data.id);
        // formData.append('file', e.target.files[0]);
        // // let Image  = 'Raj';
        //  setCustomerAgentLoginProfileNew(formData).then(
        //      (data) => {
      
        //          if (data.id > 0) {
        //              window.location.reload(true);
        //          }
        //      },
        //      (error) => {
 
        //      }
        //  );
       
        let file = e.target.files[0];
     this.getBase64(file)
      .then(result => {
        file["base64"] = result;
     
        this.setState({
          base64URL: result,
          file
        });
      })
         

            }
        };
     

   // This function will be triggered when the "Remove This Image" button is clicked
   removeSelectedImage  = () => {
       // setSelectedImage();
       this.setState({selectedImage:""}); 
    };


    EditProfile = (firstname, lastname, birthday, gender,agentname, corporatename, taxregistrationno, address, city, island, agentcountry, zipcode) => {
      
        this.setState({ editProfile: true });
        this.setState({ firstName: firstname });
        this.setState({ lastName: lastname });
        if (birthday != '0000-00-00') {
            this.setState({ birthday: new Date(birthday) });
        }

        this.setState({ gender: gender });

        this.setState({ gender: gender });
        this.setState({ editProfile: true });
        this.setState({ agentName: agentname });
        this.setState({ corporateName: corporatename });
        this.setState({ taxRegistrationno: taxregistrationno });
        this.setState({ Address: address });
        this.setState({ City: city });
        this.setState({ Island: island });
        this.setState({ AgentCountry: agentcountry });
        this.setState({ Zipcode: zipcode });
    }
    CancelProfile = () => {
        this.setState({ editProfile: false });
    }

    ShowPassword = () => {
        this.setState({ hidden: true });
    }

    HidePassword = () => {
        this.setState({ hidden: false });
    }


    EditLogin = (mobile_number, password) => {
       
        this.setState({ editLogin: true });
        this.setState({ mobile: mobile_number });
    }
    CancelLogin = () => {
        this.setState({ editLogin: false });
    }



    EditGeneral = (firstname, lastname, birthday, gender,agentname, corporatename, taxregistrationno, address, city, island, agentcountry, zipcode) => {
        this.setState({ editGeneral: true });
        this.setState({ firstName: firstname });
        this.setState({ lastName: lastname });
        if (birthday != '0000-00-00') {
            this.setState({ birthday: new Date(birthday) });
        }

        this.setState({ gender: gender });
        this.setState({ editGeneral: true });
        this.setState({ agentName: agentname });
        this.setState({ corporateName: corporatename });
        this.setState({ taxRegistrationno: taxregistrationno });
        this.setState({ Address: address });
        this.setState({ City: city });
        this.setState({ Island: island });
        this.setState({ AgentCountry: agentcountry });
        this.setState({ Zipcode: zipcode });
    }
    CancelGeneral = () => {
        this.setState({ editGeneral: false });
    }

    setFirstName = (event) => {
        let firstregMatch = /^[a-zA-Z ]*$/.test(event.target.value);
        if (event.target.value.length > 0 && firstregMatch && event.target.value.length < 20) {
            this.setState({ firstName: event.target.value });
            this.setState({ errorFirst: false });
        } else {
            this.setState({ firstName: event.target.value });
            this.setState({ errorFirst: true });
        }

    }

    setLastName = (event) => {
        let lastregMatch = /^[a-zA-Z ]*$/.test(event.target.value);
        if (event.target.value.length > 0 && lastregMatch && event.target.value.length < 20) {
            this.setState({ lastName: event.target.value });
            this.setState({ errorLast: false });
        } else {
            this.setState({ lastName: event.target.value });
            this.setState({ errorLast: true });
        }

    }

    setBirthday = (value) => {
        this.setState({ birthday: value });
    }

    setGender = (event) => {
        if (event.target.value != "Select") {
            this.setState({ gender: event.target.value });
            this.setState({ errorGender: false });
        } else {
            this.setState({ gender: event.target.value });
            this.setState({ errorGender: true });
        }

    }

    setMobile = (event) => {
        if (event.target.value.length > 5) {
            this.setState({ mobile: event.target.value });
            this.setState({ errorMobile: false });
        } else if (event.target.value.length > 15) {
            this.setState({ mobile: event.target.value });
            this.setState({ errorMobile: true });
        } else {
            this.setState({ mobile: event.target.value });
            this.setState({ errorMobile: true });
        }

    }
    OnChangeMobileCode = (event) => {
     
        this.setState({MobileCode: event.target.value});
    }

    setPassword = (event) => {
        if (event.target.value.length > 0) {
            this.setState({ password: event.target.value });
            this.setState({ errorPassword: false });
        } else {
            this.setState({ password: event.target.value });
            this.setState({ errorPassword: true });
        }

    }

    setConfPassword = (event) => {
        if (event.target.value.length > 0 && event.target.value == this.state.password) {
            this.setState({ ConfirmPassword: event.target.value });
            this.setState({ errorConfirm: false });
        } else {
            this.setState({ ConfirmPassword: event.target.value });
            this.setState({ errorConfirm: true });
        }

    }

   
    setAgentName = (event) => {
        if (event.target.value.length > 0) {
            this.setState({ agentName: event.target.value });
            this.setState({ erroragentName: false });
        } else {
            this.setState({ agentName: event.target.value });
            this.setState({ erroragentName: true });
        }

    }

    setCorporateName = (event) => {
        if (event.target.value.length > 0) {
            this.setState({ corporateName: event.target.value });
            this.setState({ errorcorporateName: false });
        } else {
            this.setState({ corporateName: event.target.value });
            this.setState({ errorcorporateName: true });
        }

    }

    setTaxRegistrationno = (event) => {
        if (event.target.value.length > 0) {
            this.setState({ taxRegistrationno: event.target.value });
            this.setState({ errortaxRegistrationno: false });
        } else {
            this.setState({ taxRegistrationno: event.target.value });
            this.setState({ errortaxRegistrationno: true });
        }

    }
    setAddress = (event) => {
        if (event.target.value.length > 0) {
            this.setState({ Address: event.target.value });
            this.setState({ errorAddress: false });
        } else {
            this.setState({ Address: event.target.value });
            this.setState({ errorAddress: true });
        }

    }

    setCity = (event) => {
        if (event.target.value.length > 0) {
            this.setState({ City: event.target.value });
            this.setState({ errorCity: false });
        } else {
            this.setState({ City: event.target.value });
            this.setState({ errorCity: true });
        }

    }

    setIsland = (event) => {
        if (event.target.value.length > 0) {
            this.setState({ Island: event.target.value });
            this.setState({ errorIsland: false });
        } else {
            this.setState({ Island: event.target.value });
            this.setState({ errorIsland: true });
        }

    }

    setAgentCountry = (event) => {
        if (event.target.value.length > 0) {
            this.setState({ AgentCountry: event.target.value });
            this.setState({ errorAgentCountry: false });
        } else {
            this.setState({ AgentCountry: event.target.value });
            this.setState({ errorAgentCountry: true });
        }

    }
    setZipcode = (event) => {
        if (event.target.value.length > 0) {
            this.setState({ Zipcode: event.target.value });
            this.setState({ errorZipcode: false });
        } else {
            this.setState({ Zipcode: event.target.value });
            this.setState({ errorZipcode: true });
        }

    }


    SaveData = (data) => {
        let CheckErrorFirstName = false;
        let CheckErrorLastName = false;
      
        let firstregMatch = /^[a-zA-Z ]*$/.test(this.state.firstName);
        if (this.state.firstName.length > 0 && firstregMatch && this.state.firstName.length < 20) {
       // if (this.state.firstName.length > 0) {
                CheckErrorFirstName = true;
            this.setState({ errorFirst: false });
        } else {
            CheckErrorFirstName = false;
            this.setState({ errorFirst: true });
        }
        let lastregMatch = /^[a-zA-Z ]*$/.test(this.state.lastName);
        if (this.state.lastName.length > 0 && lastregMatch  && this.state.lastName.length < 20) {
        //if (this.state.lastName.length > 0) {
            CheckErrorLastName = true;
            this.setState({ errorLast: false });
        } else {
            CheckErrorLastName = false;
            this.setState({ errorLast: true });
        }

        if (
            CheckErrorFirstName == true &&
            CheckErrorLastName == true 
          ) {
        let first_name = this.state.firstName;
        let last_name = this.state.lastName;
        let email = data.email;
        let profile_image = data.profile_pic;
        let birthday = moment(this.state.birthday).format("y-MM-DD");
        let gender = this.state.gender;
        let login_source = data.login_source;

        // let agent_name = this.state.agentName;
        // let corporate_name = this.state.corporateName;
        // let tax_registration = this.state.taxRegistrationno;
        // let address = this.state.Address;
        // let city = this.state.City;
        // let island = this.state.Island;
        // let agent_country = this.state.AgentCountry;
        // let zip_code = this.state.Zipcode;
        let agent_name = data.agent_name;
        let corporate_name = data.corporate_name;
        let tax_registration = data.tax_registration;
        let address = data.address;
        let city = data.city;
        let island = data.island;
        let agent_country = data.agent_country;
        let zip_code = data.zip_code;


        let mobile_number = data.mobile_number;
        let country = data.country;
        let country_code = data.country_code;
        let currency = data.currency;
        let ip_address = data.ip_address;
        let password = "";
        let verified = 1;

        setCustomerAgentLogin(first_name, last_name, email, profile_image, birthday, gender, login_source, mobile_number, country, country_code, currency, ip_address, password, verified, agent_name, corporate_name, tax_registration, address, city, island, agent_country, zip_code).then(
            (data) => {
              
                if (data.id > 0) {
                    window.location.reload(true);
                }
            },
            (error) => {

            }
        );
    }
    }

    SaveDataLogin = (data) => {
        let CheckErrorPassword = false;
        let CheckErrorConfirmPassword = false;
        let CheckErrorMobile = false;

        if (this.state.mobile.length > 5) {
                CheckErrorMobile = true;
            this.setState({ errorMobile: false });
        } else if (this.state.mobile.length > 15) {
                CheckErrorMobile = true;
            this.setState({ errorMobile: false });
        } else {
            CheckErrorMobile = false;
            this.setState({ errorMobile: true });
        }

        if (this.state.password.length > 0) {
             CheckErrorPassword = true;
            this.setState({ errorPassword: false });
        } else {
            CheckErrorPassword = false;
            this.setState({ errorPassword: true });
        }
       
         
        if (this.state.ConfirmPassword.length > 0 && this.state.ConfirmPassword == this.state.password) {
            CheckErrorConfirmPassword = true;
            this.setState({ errorConfirm: false });
        } else {
            CheckErrorConfirmPassword = false;
            this.setState({ errorConfirm: true });
        }
        
        if (
            CheckErrorPassword == true &&
            CheckErrorConfirmPassword == true &&
            CheckErrorMobile == true
          ) {
        
          let mobileCodeData = data.country_code;
         if(this.state.MobileCode != ""){
            mobileCodeData = this.state.MobileCode;
         }   
        let first_name = data.first_name;
        let last_name = data.last_name;
        let email = data.email;
        let profile_image = data.profile_pic;
        let birthday = moment(data.birthday).format("y-MM-DD");
        let gender = data.gender;
        let login_source = data.login_source;
        let agent_name = data.agent_name;
        let corporate_name = data.corporate_name;
        let tax_registration = data.tax_registration;
        let address = data.address;
        let city = data.city;
        let island = data.island;
        let agent_country = data.agent_country;
        let zip_code = data.zip_code;
        let mobile_number = this.state.mobile;
        let country = data.country;
        let country_code = this.state.MobileCode;
        let currency = data.currency;
        let ip_address = data.ip_address;
        let password = this.state.password;
        let verified = 1;

        setCustomerAgentLogin(first_name, last_name, email, profile_image, birthday, gender, login_source, mobile_number, country, country_code, currency, ip_address, password, verified, agent_name, corporate_name, tax_registration, address, city, island, agent_country, zip_code).then(
            (data) => {
               
                if (data.id > 0) {
                    window.location.reload(true);
                }
            },
            (error) => {

            }
        );
    }
    }

    SaveDataGeneral = (data) => {
        let CheckErrorCorporateName = false;
        let CheckErrorTaxRegistrationno = false;
        let CheckErrorAddress = false;
        let CheckErrorCity = false;
        let CheckErrorIsland = false;
        let CheckErrorAgentCountry = false;
        let CheckErrorZipcode = false;
      
        if (this.state.corporateName.length > 0) {
            CheckErrorCorporateName = true;
            this.setState({ errorcorporateName: false });
        } else {
            CheckErrorCorporateName = false;
            this.setState({ errorcorporateName: true });
        }

        if (this.state.taxRegistrationno.length > 0) {
            CheckErrorTaxRegistrationno = true;
            this.setState({ errortaxRegistrationno: false });
        } else {
            CheckErrorTaxRegistrationno = false;
            this.setState({ errortaxRegistrationno: true });
        }

        if (this.state.Address.length > 0) {
            CheckErrorAddress = true;
            this.setState({ errorAddress: false });
        } else {
            CheckErrorAddress = false;
            this.setState({ errorAddress: true });
        }

        if (this.state.City.length > 0) {
            CheckErrorCity = true;
            this.setState({ errorCity: false });
        } else {
            CheckErrorCity = false;
            this.setState({ errorCity: true });
        }

        if (this.state.Island.length > 0) {
            CheckErrorIsland = true;
            this.setState({ errorIsland: false });
        } else {
            CheckErrorIsland = false;
            this.setState({ errorIsland: true });
        }
       
        if (this.state.AgentCountry.length > 0) {
            CheckErrorAgentCountry = true;
            this.setState({ errorAgentCountry: false });
        } else {
            CheckErrorAgentCountry = false;
            this.setState({ errorAgentCountry: true });
        }

        if (this.state.Zipcode.length > 0) {
            CheckErrorZipcode = true;
            this.setState({ errorZipcode: false });
        } else {
            CheckErrorZipcode = false;
            this.setState({ errorZipcode: true });
        }


        if (CheckErrorCorporateName == true && CheckErrorTaxRegistrationno  == true && CheckErrorAddress  == true && CheckErrorCity  == true && CheckErrorIsland  == true && CheckErrorAgentCountry  == true && CheckErrorZipcode == true 
          ) {
        let first_name = data.first_name;
        let last_name = data.last_name;
        let email = data.email;
        let profile_image = data.profile_pic;
        let birthday = moment(data.birthday).format("y-MM-DD");
        let gender = data.gender;
        let login_source = data.login_source;
        let agent_name = this.state.agentName;
        let corporate_name = this.state.corporateName;
        let tax_registration = this.state.taxRegistrationno;
        let address = this.state.Address;
        let city = this.state.City;
        let island = this.state.Island;
        let agent_country = this.state.AgentCountry;
        let zip_code = this.state.Zipcode;
        let mobile_number = data.mobile_number;
        let country = data.country;
        let country_code = data.country_code;
        let currency = data.currency;
        let ip_address = data.ip_address;
        let password = "";
        let verified = 1;

        setCustomerAgentLogin(first_name, last_name, email, profile_image, birthday, gender, login_source, mobile_number, country, country_code, currency, ip_address, password, verified, agent_name, corporate_name, tax_registration, address, city, island, agent_country, zip_code).then(
            (data) => {
             
                if (data.id > 0) {
                    window.location.reload(true);
                }
            },
            (error) => {

            }
        );
    }
    }

    componentDidMount() {
        const customerEmail = localStorage.getItem('userDetails');

        const EmailNew = JSON.parse(customerEmail);

        if (EmailNew == null) {
         
            this.setState({ Redirect: true });
        } else {
          
            getCustomerLogin(EmailNew.email).then(
                (data) => {
                   
                    this.setState({ customerDetails: data });
                },
                (error) => {

                });
        }
    //Commision 
            getAgentCommissionDetails(EmailNew.uid).then(
                (data) => {
                    this.setState({ Commission: data });
                },
                (error) => {

                });

    }



    render() {
      
        if (this.state.Redirect) {
            return <Redirect to="/" />
        }
      
        return (
            <div>
                 <Helmet>
                <title> Profile: Holidays Seychelles</title>
                <meta name="keywords" content="Seychelles, Seychellen, best place for honeymoon,most beautiful places in the world,best honeymoon destination in the world,honeymoon places,honeymoon destinations,beautiful places in the world"/>
                </Helmet>
                <h1 style={{color:'#fff'}}> Profile: Holidays Seychelles</h1>
                <NewHeader page={'inner_listing'} />
                <div className="TripContainer" id="container">
                    <div className={this.state.ChangeColor} style={{ marginTop: '-5px' }}>
                        <div className="landingContainer"><h4>My Profile</h4>
                        </div>
                    </div>

                    {this.state.customerDetails == {} ? (
                        <></>
                    ) : (
                        <div className="contentWrapper contentWrapper--myProfile">
                            <div className="leftSecWrapper">
                                <div className="profilSdeBar profilSdeBar--sticky">
                                    <div className={this.state.customerDetails.login_source == 1 ? "proflPicContanr" : "proflPicContanr proflPicContanrNew"}>
                                        {this.state.customerDetails.profile_pic == "" ? (
                                            <div className="proflPicContanr__nmeIniContanr">
                                                <span className="latoBlack whiteText proflPicContanr__nmeIni">{this.state.customerDetails.first_name.charAt(0)}</span>
                                            </div>
                                        ) : (
                                            <img src={this.state.customerDetails.profile_pic} />
                                        )}

                                    </div>
                                    <div className="profilSdeBar__contntWrap">
                                        <p className="font20 latoBlack blackText" style={{ textTransform: 'capitalize' }}>{this.state.customerDetails.first_name + ' ' + this.state.customerDetails.last_name}</p>
                                        <p className="font12 darkGreyText appendTop10">Personal Profile</p>
                                    </div>
                                </div>

                               {/* <Imageupload agent_id={this.state.customerDetails.id}></Imageupload> */}


                                {/* <div className="profilSdeBar profilSdeBar--sticky">
                                <p className="imageProfile">
                                            <span>Kindly Upload the Agent Company Logo</span>
                                </p>
                                    <div className={this.state.customerDetails.login_source == 1 ? "proflPicContanrImage" : "proflPicContanrImage proflPicContanrImageNew"}>
                                       
                                            { this.state.selectedImage ? (
                                        <div>
                                            <img
                                            src={URL.createObjectURL(this.state.selectedImage)}
                                             style={{height: '100px', width: '100%'}}
                                            />
                                           
                                        </div>
                                        ):( <div>
                                            <img
                                            src={this.state.customerDetails.agentimageurl }
                                            style={{height: '100px', width: '100%'}}
                                            />
                                          
                                        </div>)}
                                    </div>
                                    <div className="profilSdeBar__contntWrap" style={{ padding: '20px' }}>
                                       
                                        <input
                                        accept=".png,.jpg,.jpeg"
                                        type="file"
                                        onChange={this.imageChange}
                                        />
                                    </div>
                                    <p style={{ color: '#d51a1a', margin: '10px' }}>Note:- Profile image not more than 200kb</p>
                                </div> */}


                                {/* <div className="profilSdeBar" style={{marginTop:'20px'}}>
                                   
                                    <div className="profilSdeBar__contntWrap">
                                    <p className="font20 latoBlack blackText" style={{ textTransform: 'capitalize' }}>Less Discount({this.state.Commission}%)</p>
                                       
                                    </div>
                                </div> */}
                            </div>

                            <div className="rightSecWrapper">
                                <div className="proflCmpltonStats cm__myProfileTheme">
                                    <div className="darkGreyText proflCmpltonStats__prcntagSec">

                                        {this.state.customerDetails.first_name && this.state.customerDetails.last_name && this.state.customerDetails.birthday && this.state.customerDetails.gender && this.state.customerDetails.mobile_number && this.state.customerDetails.password && this.state.customerDetails.corporate_name &&  this.state.customerDetails.tax_registration &&  this.state.customerDetails.address &&  this.state.customerDetails.city && this.state.customerDetails.island && this.state.customerDetails.agent_country && this.state.customerDetails.zip_code ? (
                                            <>
                                                <p className="latoBold ProfilemakeFlex ProfilespaceBetween">
                                                    <span>Your profile is complete</span>
                                                    <span className="latoBlack blackText">100%</span>
                                                </p>
                                                <div className="proflCmpltonStats__progrsBar">
                                                    <div className="proflCmpltonStats__progrsBarFill" style={{ width: '100%' }}></div>
                                                </div>
                                            </>

                                        ) : (
                                            this.state.customerDetails.first_name && this.state.customerDetails.last_name && this.state.customerDetails.birthday && this.state.customerDetails.gender ? (
                                                <>
                                                    <p className="latoBold ProfilemakeFlex ProfilespaceBetween">
                                                        <span>Your profile is complete</span>
                                                        <span className="latoBlack blackText">50%</span>
                                                    </p>
                                                    <div className="proflCmpltonStats__progrsBar">
                                                        <div className="proflCmpltonStats__progrsBarFill" style={{ width: '70%' }}></div>
                                                    </div>
                                                </>
                                            ) :  (
                                                    <>
                                                        <p className="latoBold ProfilemakeFlex ProfilespaceBetween">
                                                            <span>Your profile is complete</span>
                                                            <span className="latoBlack blackText">10%</span>
                                                        </p>
                                                        <div className="proflCmpltonStats__progrsBar">
                                                            <div className="proflCmpltonStats__progrsBarFill" style={{ width: '30%' }}></div>
                                                        </div>
                                                    </>
                                                )
                                            

                                        )}


                                    </div>
                                    {this.state.customerDetails.first_name && this.state.customerDetails.last_name && this.state.customerDetails.birthday && this.state.customerDetails.gender && this.state.customerDetails.mobile_number && this.state.customerDetails.password && this.state.customerDetails.corporate_name &&  this.state.customerDetails.tax_registration &&  this.state.customerDetails.address &&  this.state.customerDetails.city && this.state.customerDetails.island && this.state.customerDetails.agent_country && this.state.customerDetails.zip_code ? (
                                        <p className="darkGreyText appendTop10">Congrats! Your profile details is up to date!</p>
                                    ) : (
                                        <> </>
                                    )}

                                    <ul className="font16 latoBold proflCmpltonStats__stpsStatusLst">
                                        <li className="proflCmpltonStats__stpsStatusItm ">
                                            <span className="myPrfilSprit appendRight10 myPrfilSprit__verifiedBig">

                                            </span>Email-ID Verified</li>
                                        {/* {this.state.customerDetails.mobile_number ? (
                                            <li className="proflCmpltonStats__stpsStatusItm ">
                                                <span className="myPrfilSprit appendRight10 myPrfilSprit__verifiedBig"></span>Verified mobile Number
                                            </li>
                                        ) : (
                                            <li className="proflCmpltonStats__stpsStatusItm ">
                                                <span className="myPrfilSprit appendRight10 myPrfilSprit__notverifiedBig"></span>Add Mobile Number
                                            </li>
                                        )} */}

                                        {this.state.customerDetails.first_name && this.state.customerDetails.last_name && this.state.customerDetails.birthday && this.state.customerDetails.gender &&  this.state.customerDetails.corporate_name &&  this.state.customerDetails.tax_registration &&  this.state.customerDetails.address &&  this.state.customerDetails.city && this.state.customerDetails.island && this.state.customerDetails.agent_country && this.state.customerDetails.zip_code ? (
                                            <li className="proflCmpltonStats__stpsStatusItm "><span className="myPrfilSprit appendRight10 myPrfilSprit__verifiedBig"></span>Completed Basic Info</li>
                                        ) : (
                                            <li className="proflCmpltonStats__stpsStatusItm "><span className="myPrfilSprit appendRight10 myPrfilSprit__notverifiedBig"></span>Add Basic Info</li>
                                        )}


                                    </ul>
                                </div>

                                <div className="profilCompont cm__myTripSideBar cm__myProfileTheme" id="profilePageComponent0"><div className="detalCrdHadr undefined"><div className="appendRight10"><h3 className="font30 latoBold blackText">Profile</h3><p className="font18 darkGreyText appendTop10">Basic info, for a faster booking experience</p></div><div>

                                    {this.state.editProfile == true ? (
                                        <button type="button" className="font16 latoBold blueText btn__dtailAdEdt" style={{ color: 'rgb(24 133 203)', outline: 0 }} onClick={this.CancelProfile}>
                                            Cancel</button>
                                    ) : (
                                        <button type="button" className="font16 latoBold blueText btn__dtailAdEdt"
                                            onClick={() => this.EditProfile(this.state.customerDetails.first_name, this.state.customerDetails.last_name, this.state.customerDetails.birthday, this.state.customerDetails.gender, this.state.customerDetails.agent_name,  this.state.customerDetails.corporate_name,  this.state.customerDetails.tax_registration,  this.state.customerDetails.address,  this.state.customerDetails.city,  this.state.customerDetails.island, this.state.customerDetails.agent_country, this.state.customerDetails.zip_code)} style={{ color: 'rgb(24 133 203)', outline: 0 }} >
                                            Edit</button>
                                    )}
                                </div></div>

                                    {this.state.editProfile == true ? (
                                        <>
                                            <div className="paymakeFlex" style={{ marginTop: 55 }}>
                                                <div className="paymakeFlex column flexOne">
                                                    <div className="paymakeFlex">
                                                        <div className="guestDtls__col width247 appendRight10" style={{ width: 300 }}>
                                                            <div className="textFieldCol ">
                                                                <p className="font11 appendBottom10 guestDtlsTextLbl">
                                                                    <span className="capText">First Name</span></p>
                                                                <input type="text" className={`frmTextInput ${this.state.errorFirst ? "Err" : ""}`} placeholder="First Name" value={this.state.firstName} onChange={this.setFirstName} />
                                                                {this.state.errorFirst && <p className="error">Please enter your first name in allphabet min 1 or max 20 characters </p>}
                                                            </div>
                                                        </div>
                                                        <div className="guestDtls__col width247" style={{ width: 300 }} >
                                                            <div className="textFieldCol ">
                                                                <p className="font11 appendBottom10 guestDtlsTextLbl">
                                                                    <span className="capText">Last Name</span></p>
                                                                <input type="text" id="lName" name="lName" className={`frmTextInput ${this.state.errorLast ? "Err" : ""}`}  placeholder="Last Name" value={this.state.lastName} onChange={this.setLastName} />
                                                                {this.state.errorLast && <p className="error">Please enter your last name in allphabet min 1 or max 20 characters </p>}
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                            <div className="paymakeFlex" >
                                                <div className="paymakeFlex column flexOne">
                                                    <div className="paymakeFlex">
                                                        <div className="guestDtls__col width247 appendRight10" style={{ width: 300 }}>
                                                            <div className="textFieldCol ">
                                                                <p className="font11 appendBottom10 guestDtlsTextLbl">
                                                                    <span className="capText">Birthday</span></p>
                                                                <DatePicker value={this.state.birthday} onChange={(value) => { this.setBirthday(value) }} className="frmTextInput " maxDate={new Date()} format="dd-MM-y" />
                                                                
                                                            </div>
                                                        </div>
                                                        <div className="guestDtls__col width247" style={{ width: 300 }} >
                                                            <div className="textFieldCol ">
                                                                <p className="font11 capText appendBottom10">Gender</p>
                                                                <div className="frmSelectCont">
                                                                    <select id="title" className={`frmSelect ${this.state.errorGender ? "Err" : ""}`} value={this.state.gender} onChange={this.setGender}>
                                                                        <option value="Select">---</option>
                                                                        <option value="Male">Male</option>
                                                                        <option value="Female">Female</option>
                                                                        <option value="Other">Other</option>
                                                                    </select>
                                                                    {this.state.errorGender && <p className="error">Please select your Gender </p>}
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>




                                            </div>
                                            <button type="button" className="font16 latoBold blueText btn__dtailAdSave" onClick={() => this.SaveData(this.state.customerDetails)}>
                                                Save</button></>
                                    ) : (
                                        <ul className="profilCompont__dtalLst"><li className="profilCompont__dtalLstItm"><div className="profilCompont__dtalLstItmContnt"><span className="font11 darkGreyText profilCompont__detalkey">FIRST NAME</span><span className="font16 blackText latoBold" style={{ textTransform: 'capitalize' }}>{this.state.customerDetails.first_name}</span></div></li>
                                            <li className="profilCompont__dtalLstItm"><div className="profilCompont__dtalLstItmContnt"><span className="font11 darkGreyText profilCompont__detalkey">LAST NAME</span><span className="font16 blackText latoBold" style={{ textTransform: 'capitalize' }}>{this.state.customerDetails.last_name}</span></div></li><li className="profilCompont__dtalLstItm"><div className="profilCompont__dtalLstItmContnt"><span className="font11 darkGreyText profilCompont__detalkey">BIRTHDAY</span><span className="font16 blackText latoBold">{this.state.customerDetails.birthday == "0000-00-00" ? '---' : moment(this.state.customerDetails.birthday).format("D MMM Y")}</span></div></li><li className="profilCompont__dtalLstItm"><div className="profilCompont__dtalLstItmContnt"><span className="font11 darkGreyText profilCompont__detalkey">GENDER</span><span className="font16 blackText latoBold" style={{ textTransform: 'capitalize' }}>{this.state.customerDetails.gender == "" ? "---" : this.state.customerDetails.gender}</span></div></li></ul>
                                    )}




                                </div>
                                <div className="lognDtalComp cm__myTripSideBar cm__myProfileTheme" id="profilePageComponent1"><div className="detalCrdHadr undefined">
                                    <div className="appendRight10"><h3 className="font30 latoBold blackText">Login Details</h3>
                                        <p className="font18 darkGreyText appendTop10">Manage your mobile number and password</p></div>
                                    <div>

                                        {this.state.editLogin == true ? (
                                            <button type="button" className="font16 latoBold blueText btn__dtailAdEdt" style={{ color: 'rgb(24 133 203)', outline: 0 }} onClick={this.CancelLogin}>
                                                Cancel</button>
                                        ) : (
                                            <button type="button" className="font16 latoBold blueText btn__dtailAdEdt"
                                                onClick={() => this.EditLogin(this.state.customerDetails.mobile_number, this.state.customerDetails.password)} style={{ color: 'rgb(24 133 203)', outline: 0 }} >
                                                Edit</button>
                                        )}
                                    </div>
                                </div>
                                    {this.state.editLogin == true ? (
                                        <>
                                            <div className="guestDtls__row" style={{ marginTop: 40 }}>
                                                <div className="paymakeFlex">
                                                    <div className="guestDtls__col width327 appendRight10">
                                                        <div className="textFieldCol " style={{ position: 'relative' }}>
                                                            <p className="font11 appendBottom10 guestDtlsTextLbl">
                                                                <span className="capText">New Password</span>
                                                            </p>
                                                            <input type={this.state.hidden ? 'text' : 'password'} className={`frmTextInput ${this.state.errorPassword ? "Err" : ""}`} placeholder="New Password" value={this.state.password} onChange={this.setPassword} />
                                                            {this.state.hidden == true ? (
                                                                <span className={`myPrfilSprit  txtFild__rightpasswordIcon myPrfilSprit__hidePswrd newreset ${this.state.errorPassword ? "ErrSpan" : ""}`}  onClick={this.HidePassword}></span>
                                                            ) : (
                                                                <span className={`myPrfilSprit  txtFild__rightpasswordIcon myPrfilSprit__showPswrd newreset ${this.state.errorPassword ? "ErrSpan" : ""}`} onClick={this.ShowPassword}></span>
                                                            )}
                                                            {this.state.errorPassword && <p className="error">Please enter your password </p>}

                                                        </div>
                                                    </div>
                                                    <div className="guestDtls__col width327 appendRight10">
                                                        <div className="textFieldCol " style={{ position: 'relative' }}>
                                                            <p className="font11 appendBottom10 guestDtlsTextLbl">
                                                                <span className="capText">Confirm Password</span>
                                                            </p>
                                                            <input type={this.state.hidden ? 'text' : 'password'} className={`frmTextInput ${this.state.errorConfirm ? "Err" : ""}`} placeholder="Confirm Password" value={this.state.ConfirmPassword} onChange={this.setConfPassword} />
                                                            {this.state.hidden == true ? (
                                                                <span className={`myPrfilSprit  txtFild__rightpasswordIcon myPrfilSprit__hidePswrd  ${this.state.errorConfirm ? "ErrSpan" : ""}`}  onClick={this.HidePassword}></span>
                                                            ) : (
                                                                <span className={`myPrfilSprit  txtFild__rightpasswordIcon myPrfilSprit__showPswrd  ${this.state.errorConfirm ? "ErrSpan" : ""}`} onClick={this.ShowPassword}></span>
                                                            )}
                                                            {this.state.errorConfirm && <p className="error">Password do not match! </p>}

                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="paymakeFlex" style={{marginTop:20}}>
                                                    <div className="guestDtls__col width327">
                                                        <p className="font11 capText appendBottom10">Mobile Number</p>
                                                        <div className="paymakeFlex textLtr">
                                                            <div className="guestDtls__contact">
                                                                <label for="mCode" className=" frmSelectCont__contact">
                                                                    <select id="mCode" className="frmSelect frmSelectContact" value={this.state.MobileCode} onChange={this.OnChangeMobileCode}>
                                                                        {DialCode.map((item, key) => (
                                                                            <option value={item.dial_code}>{item.name}&nbsp;({item.dial_code})</option>
                                                                        ))}
                                                                    </select>
                                                                </label><span className="selectedCode">{this.state.MobileCode == ""? this.state.customerDetails.country_code :this.state.MobileCode}</span></div>
                                                            <div className="flexOne">

                                                                <div className="textFieldCol ">
                                                                    <input type="text" id="mNo" name="mNo" className={`frmTextInput noLeftBorder ${this.state.errorMobile ? "Err" : ""}`} placeholder="Mobile Number" value={this.state.mobile} onChange={this.setMobile} />
                                                                    {this.state.errorMobile && <p className="error">Please enter valid number </p>}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <button type="button" className="font16 latoBold blueText btn__dtailAdSave" onClick={() => this.SaveDataLogin(this.state.customerDetails)}>
                                                Save</button>
                                        </>
                                    ) : (
                                        <ul className="lognDtalComp__dtalLst">
                                            <li className="lognDtalComp__dtalLstItm">
                                                <div className="lognDtalComp__dtalLstItmContnt">
                                                    <span className="font11 darkGreyText lognDtalComp__detalkey">MOBILE NUMBER</span>
                                                    <span className="font16 blackText latoBold">&lrm;{
                                                        this.state.customerDetails.mobile_number ? this.state.customerDetails.country_code + '-' + this.state.customerDetails.mobile_number : "----"}</span>
                                                </div>
                                            </li>
                                            <li className="lognDtalComp__dtalLstItm">
                                                <div className="lognDtalComp__dtalLstItmContnt">
                                                    <span className="font11 darkGreyText lognDtalComp__detalkey">EMAIL ID</span>
                                                    <span className="font16 blackText latoBold">&lrm;{this.state.customerDetails.email}</span>
                                                </div>
                                            </li>
                                            <li className="lognDtalComp__dtalLstItm">
                                                <div className="lognDtalComp__dtalLstItmContnt">
                                                    <span className="font11 darkGreyText lognDtalComp__detalkey">PASSWORD</span>
                                                        <span className="blacktext latoBold lognDtalComp__pswrdTxt" style={{ WebkitTextSecurity: 'disc' }}>123456</span>
                                                   

                                                </div>
                                            </li>
                                        </ul>
                                    )}
                                </div>


                                {/* <div className="profilCompont cm__myTripSideBar cm__myProfileTheme" id="profilePageComponent2"><div className="detalCrdHadr" style={{marginBottom: '25px'}}><div className="appendRight10"><h3 className="font30 latoBold blackText">General Information				</h3><p className="font18 darkGreyText appendTop10">General info, for a faster booking experience</p></div><div>

                                    {this.state.editGeneral == true ? (
                                        <button type="button" className="font16 latoBold blueText btn__dtailAdEdt" style={{ color: 'rgb(24 133 203)', outline: 0 }} onClick={this.CancelGeneral}>
                                            Cancel</button>
                                    ) : (
                                        <button type="button" className="font16 latoBold blueText btn__dtailAdEdt"
                                            onClick={() => this.EditGeneral(this.state.customerDetails.first_name, this.state.customerDetails.last_name, this.state.customerDetails.birthday, this.state.customerDetails.gender, this.state.customerDetails.agent_name,  this.state.customerDetails.corporate_name,  this.state.customerDetails.tax_registration,  this.state.customerDetails.address,  this.state.customerDetails.city,  this.state.customerDetails.island, this.state.customerDetails.agent_country, this.state.customerDetails.zip_code)} style={{ color: 'rgb(24 133 203)', outline: 0 }} >
                                            Edit</button>
                                    )}
                                </div></div>

                                    {this.state.editGeneral == true ? (
                                        <>
                                           
                                            <div className="paymakeFlex" >
                                                <div className="paymakeFlex column flexOne">
                                                    <div className="paymakeFlex">
                                                        <div className="guestDtls__col width247 appendRight10" style={{ width: 300 }}>
                                                        <div className="textFieldCol ">
                                                                <p className="font11 appendBottom10 guestDtlsTextLbl">
                                                                    <span className="capText">Corporate Name</span></p>
                                                                    <input type="text" className={`frmTextInput ${this.state.errorcorporateName ? "Err" : ""}`} placeholder="Corporate Name" value={this.state.corporateName} onChange={this.setCorporateName} />
                                                                    {this.state.errorcorporateName && <p className="error">Please enter your Corporate Name </p>}
                                                            </div>
                                                        </div>
                                                        
                                                        <div className="guestDtls__col width247" style={{ width: 300 }} >
                                                        <div className="textFieldCol ">
                                                                <p className="font11 appendBottom10 guestDtlsTextLbl">
                                                                    <span className="capText">Tax Registration No</span></p>
                                                                <input type="text" className={`frmTextInput ${this.state.errortaxRegistrationno ? "Err" : ""}`} placeholder="Tax Registration No" value={this.state.taxRegistrationno} onChange={this.setTaxRegistrationno} />
                                                                {this.state.errortaxRegistrationno && <p className="error">Please enter your Tax Registration No </p>}
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>

                                            <div className="paymakeFlex" >
                                                <div className="paymakeFlex column flexOne">
                                                    <div className="paymakeFlex">
                                                        <div className="guestDtls__col width247 appendRight10" style={{ width: 300 }}>
                                                        <div className="textFieldCol ">
                                                                <p className="font11 appendBottom10 guestDtlsTextLbl">
                                                                    <span className="capText">Address</span></p>
                                                                <input type="text" className={`frmTextInput ${this.state.errorAddress ? "Err" : ""}`} placeholder="Address" value={this.state.Address} onChange={this.setAddress} />
                                                                {this.state.errorAddress && <p className="error">Please enter your Address</p>}
                                                            </div>
                                                        </div>
                                                        <div className="guestDtls__col width247" style={{ width: 300 }} >
                                                        <div className="textFieldCol ">
                                                                <p className="font11 appendBottom10 guestDtlsTextLbl">
                                                                    <span className="capText">City</span></p>
                                                                <input type="text" className={`frmTextInput ${this.state.errorCity ? "Err" : ""}`} placeholder="City" value={this.state.City} onChange={this.setCity} />
                                                                {this.state.errorCity && <p className="error">Please enter your City </p>}
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                            <div className="paymakeFlex" >
                                                <div className="paymakeFlex column flexOne">
                                                    <div className="paymakeFlex">
                                                        <div className="guestDtls__col width247 appendRight10" style={{ width: 300 }}>
                                                        <div className="textFieldCol ">
                                                                <p className="font11 appendBottom10 guestDtlsTextLbl">
                                                                    <span className="capText">Island/Province</span></p>
                                                                <input type="text" className={`frmTextInput ${this.state.errorIsland ? "Err" : ""}`} placeholder="Island" value={this.state.Island} onChange={this.setIsland} />
                                                                {this.state.errorIsland && <p className="error">Please enter your Island/Province</p>}
                                                            </div>
                                                        </div>
                                                        <div className="guestDtls__col width247" style={{ width: 300 }} >
                                                        <div className="textFieldCol ">
                                                                <p className="font11 appendBottom10 guestDtlsTextLbl">
                                                                    <span className="capText">Country</span></p>
                                                                <input type="text" className={`frmTextInput ${this.state.errorAgentCountry ? "Err" : ""}`} placeholder="Country" value={this.state.AgentCountry} onChange={this.setAgentCountry} />
                                                                {this.state.errorAgentCountry && <p className="error">Please enter your Country </p>}
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                            <div className="paymakeFlex" >
                                                <div className="paymakeFlex column flexOne">
                                                    <div className="paymakeFlex">
                                                        <div className="guestDtls__col width247 appendRight10" style={{ width: 300 }}>
                                                        <div className="textFieldCol ">
                                                                <p className="font11 appendBottom10 guestDtlsTextLbl">
                                                                    <span className="capText">Zip Code</span></p>
                                                                <input type="text" className={`frmTextInput ${this.state.errorZipcode ? "Err" : ""}`} placeholder="Zipcode" value={this.state.Zipcode} onChange={this.setZipcode} />
                                                                {this.state.errorZipcode && <p className="error">Please enter your Zip Code </p>}
                                                            </div>
                                                        </div>
                                                       
                                                    </div>
                                                </div>
                                            </div>
                                            <button type="button" className="font16 latoBold blueText btn__dtailAdSave" onClick={() => this.SaveDataGeneral(this.state.customerDetails)}>
                                                Save</button></>
                                    ) : (
                                        <ul className="profilCompont__dtalLst">
                                           
                                            <li className="profilCompont__dtalLstItm"><div className="profilCompont__dtalLstItmContnt"><span className="font11 darkGreyText profilCompont__detalkey">Corporate name</span><span className="font16 blackText latoBold" style={{ textTransform: 'capitalize' }}>{this.state.customerDetails.corporate_name}</span></div></li>
                                            <li className="profilCompont__dtalLstItm"><div className="profilCompont__dtalLstItmContnt"><span className="font11 darkGreyText profilCompont__detalkey">Tax Registration No</span><span className="font16 blackText latoBold" style={{ textTransform: 'capitalize' }}>{this.state.customerDetails.tax_registration}</span></div></li>
                                            <li className="profilCompont__dtalLstItm"><div className="profilCompont__dtalLstItmContnt"><span className="font11 darkGreyText profilCompont__detalkey">Address</span><span className="font16 blackText latoBold" style={{ textTransform: 'capitalize' }}>{this.state.customerDetails.address}</span></div></li>
                                            <li className="profilCompont__dtalLstItm"><div className="profilCompont__dtalLstItmContnt"><span className="font11 darkGreyText profilCompont__detalkey">City</span><span className="font16 blackText latoBold" style={{ textTransform: 'capitalize' }}>{this.state.customerDetails.city}</span></div></li>
                                            <li className="profilCompont__dtalLstItm"><div className="profilCompont__dtalLstItmContnt"><span className="font11 darkGreyText profilCompont__detalkey">Island/Province</span><span className="font16 blackText latoBold" style={{ textTransform: 'capitalize' }}>{this.state.customerDetails.island}</span></div></li>
                                            <li className="profilCompont__dtalLstItm"><div className="profilCompont__dtalLstItmContnt"><span className="font11 darkGreyText profilCompont__detalkey">Country</span><span className="font16 blackText latoBold" style={{ textTransform: 'capitalize' }}>{this.state.customerDetails.agent_country}</span></div></li>
                                            <li className="profilCompont__dtalLstItm"><div className="profilCompont__dtalLstItmContnt"><span className="font11 darkGreyText profilCompont__detalkey">Zip Code</span><span className="font16 blackText latoBold" style={{ textTransform: 'capitalize' }}>{this.state.customerDetails.zip_code}</span></div></li>
                                          </ul>
                                    )}




                                </div> */}
                            </div>
                        </div>
                    )}


                </div>
            </div>
        )
    }
}

export default Profile;
